



















import { Component, Vue } from "vue-property-decorator";

@Component
class ModalAuthRequire extends Vue {
  get dialog() {
    const currentPageNeedAuth = this.$store.state.app.currentPageNeedAuth;
    const logged = this.$store.getters["auth/isLogged"];
    return currentPageNeedAuth && !logged;
  }

  handleAuth() {
    this.$helper.requestLogin(this);
  }
}
export default ModalAuthRequire;
